import { render } from "./Home.vue?vue&type=template&id=79477cdd"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=79477cdd&lang=css"
script.render = render

export default script